import {useEffect} from 'react';
import {PageTitleKeys, pageTitles} from '../config/routeConstants';
import {useTranslation} from "react-i18next";

export const usePageTitle = (titleInput: PageTitleKeys | string, isKey = true) => {
    const {t} = useTranslation();

    useEffect(() => {
        if (isKey) {
            const key = titleInput as PageTitleKeys;
            document.title = t(pageTitles[key]) || pageTitles[PageTitleKeys.Default];
        } else {
            document.title = titleInput as string || pageTitles[PageTitleKeys.Default];
        }
    }, [titleInput, isKey, t]);
};
